import { AccessTypeEnum } from '../enums/access-type-enum'

export const isPartialType = (accessType: AccessTypeEnum) => {
  return (
    accessType === AccessTypeEnum.partialAccess ||
    accessType === AccessTypeEnum.partialDrippingAccess
  )
}
